import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { App as AntdApp } from "antd";
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./app/config/store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AntdApp>
      <App />
    </AntdApp>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
